import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MandateModel } from './mandate.model';
import { MatTabNav } from '@angular/material/tabs';
import { MandateService } from './mandate.service';

@Component({
    selector: 'convfact-mandate',
    templateUrl: './mandate.component.html',
    providers: [MatTabNav],
    styleUrls: ['./mandate.component.css'],
    standalone: false
})
export class MandateComponent implements OnInit {
  mandate = new MandateModel();
  errors: Record<string, unknown> = {};

  private readonly mandateService = inject(MandateService);
  private readonly router = inject(Router);

  submit(): void {}

  async saveData(mandate: MandateModel): Promise<void> {
    if (mandate.uid == null) {
      this.mandate = await this.mandateService.addData(mandate);
      this.returnToIndex();
    } else {
      this.mandate = await this.mandateService.editData(mandate.uid, mandate);
      this.returnToIndex();
    }
  }

  async ngOnInit(): Promise<void> {
    const url = this.router.url;
    const pieces = url.split('/');
    const uid = pieces[4];

    this.mandate = await this.mandateService.loadData(uid);
  }

  returnToIndex(): void {
    this.router.navigate(['/account/mandate']);
  }
}